import { IAttendance } from "@grassrootly/api/entities";
import { UpdateAttendancePayload } from "@grassrootly/api/gateways";
import server from "@grassrootly/api/providers/supabase-provider/Server";
import withErrorCheck from "../CheckError";

export const UpdateAttendance = async ({ id, playerId, attending, team, position }: UpdateAttendancePayload): Promise<IAttendance> => {
  const data = withErrorCheck(
    await server.from("GameAttendances").select("*").eq("game_id", id).eq("player_id", playerId)
  );
  let attendance = data?.length ? data[0] : null;
  if (!attendance) {
    return withErrorCheck(
      await server
        .from("GameAttendances")
        .insert({
          player_id: playerId,
          game_id: id,
          attended: attending,
          team: team,
          position: position
        })
        .select()
    )[0];
  }
  
  // Build update object conditionally
  const updateData: any = { ...attendance, attended: attending, team };
  if (position !== undefined) {
    updateData.position = position;
  }
  
  return withErrorCheck(
    await server
      .from("GameAttendances")
      .update(updateData)
      .eq("id", attendance.id)
      .select()
  )[0];
};
